/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { TitleCell_ScheduleFragmentDoc } from '../Cell/__generated__/TitleCell.graphql';
import { DescriptionCell_ScheduleFragmentDoc } from '../Cell/__generated__/DescriptionCell.graphql';
import { CreatedAtCell_ScheduleFragmentDoc } from '../Cell/__generated__/CreatedAtCell.graphql';
import { UsedByCell_ScheduleFragmentDoc } from '../Cell/__generated__/UsedByCell.graphql';
import { ActionsCell_ScheduleFragmentDoc } from '../Cell/__generated__/ActionsCell.graphql';
export type ScheduleTable_ScheduleFragment = { __typename: 'Schedule', id: string, title: string, description: string, createdAt: any, isScheduleUsedByAnyConfiguration: boolean, syncedDisplays: Array<{ __typename: 'Display', id: string }>, outOfSyncDisplays: Array<{ __typename: 'Display', id: string }>, syncingDisplays: Array<{ __typename: 'Display', id: string }>, removingDisplays: Array<{ __typename: 'Display', id: string }>, allDisplays: Array<{ __typename: 'Display', id: string }> };

export const ScheduleTable_ScheduleFragmentDoc = gql`
    fragment ScheduleTable_schedule on Schedule {
  id
  ...TitleCell_schedule
  ...DescriptionCell_schedule
  ...CreatedAtCell_schedule
  ...UsedByCell_schedule
  ...ActionsCell_schedule
}
    ${TitleCell_ScheduleFragmentDoc}
${DescriptionCell_ScheduleFragmentDoc}
${CreatedAtCell_ScheduleFragmentDoc}
${UsedByCell_ScheduleFragmentDoc}
${ActionsCell_ScheduleFragmentDoc}`;